// extracted by css-extract-rspack-plugin
export default {"container":"YyO6tmxan54i7lee"};